import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

export function getUserConfiguration(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/user/getUserConfiguration`, {
            params: {userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
